import React from "react";
import "./suspensionRepair.css";
import { Link } from "react-router-dom";  
import { Helmet } from "react-helmet";  

export default function SuspensionRepair() {
  return (
    <>
    <Helmet>
      <title>Best Suspension Repair Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Keep your car safe and smooth with professional suspension repair services at AutoCare in Palwal. We offer expert suspension maintenance and repair for all vehicles."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/suspension"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Suspension Repair Service in Palwal</h1>

          <p>
            Keep your car safe and smooth on every ride with
            <strong> professional suspension repair</strong> at
            <span className="highlight"> AutoCare</span>. We are a trusted
            <strong> car repair shop in Palwal</strong>, offering expert
            <span className="highlight"> suspension maintenance and repair</span> for all vehicles.
          </p>

          <h2>What is Suspension Repair?</h2>
          <p>
            Suspension repair involves inspecting, diagnosing, and repairing
            issues with your car’s shocks, struts, springs, and control arms.
            Proper suspension ensures smooth handling, stability, and comfort while driving.
          </p>

          <h2>Suspension Problems We Fix</h2>
          <ul>
            <li>Uneven ride height & sagging suspension</li>
            <li>Bumpy or harsh rides</li>
            <li>Worn-out shocks and struts</li>
            <li>Noisy suspension or clunking sounds</li>
            <li>Alignment issues due to suspension wear</li>
            <li>Loose or damaged control arms & bushings</li>
          </ul>

          <h2>Why Choose AutoCare for Suspension Repair?</h2>
          <ul>
            <li>Trusted <span className="highlight">suspension repair service in Palwal</span></li>
            <li>Certified mechanics with modern suspension tools</li>
            <li>Genuine replacement parts & transparent pricing</li>
            <li>Fast, reliable, and long-lasting repairs</li>
            <li>One-stop <span className="highlight">Auto Care in Palwal</span> solution</li>
          </ul>

          <h2>Suspension Repair Near You</h2>
          <p>
            Searching for the <span className="highlight">best suspension repair near me</span>?
            Choose <strong>AutoCare</strong> for professional, safe, and affordable
            <strong> car suspension repair services</strong>.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Suspension Repair Service
            </Link>
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="imageContent">
          <img
            src="/carServiceImages/suspension Repair.webp"
            alt="Best Suspension Repair Service in Palwal | AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
